import React, { useContext, useEffect } from 'react';
import '../../../Styles/OpenOrders.scss'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from '@material-ui/core/styles';
import useFetch from 'CustomHooks/useFetch';
import OpenOrderLine from './OpenOrderLine';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import { getFormattedDateTime } from '../../../Util/DateFunctions';
import useGuiTranslations from '../../MultiLanguage/useGuiTranslations';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

export default function OpenOrders__Details__Small_2(props) {
  const theme = useTheme();
  const [updateOrderItemHookResponse, updateOrderItemHook] = useFetch();
  const classes = useStyles();
  const [translateGui] = useGuiTranslations();

  const updateOrderItem = (itemId) => {
    console.log('getting orders');
    updateOrderItemHook(
      {
        url: `/admin/orders/${props.order.orderNumber}/${itemId}`,
        addTokenHeader: true,
        method: 'GET',
        postData: null,
      }
    );
  }




  return (
    <React.Fragment>

      <div className={classes.root}>
        <div className={classes.col1}>

          <div className={classes.orderTypeWrapper}>
            <span style={{ display: 'inline' }}>
              {
                props.order.orderType == "SelfOrder" ?
                  <RestaurantIcon className={classes.restaurantIcon}></RestaurantIcon>
                  : null
              }
              {
                props.order.orderType == "Collect" ?
                  <DirectionsWalkIcon className={classes.directionsWalkIcon}></DirectionsWalkIcon>
                  : null
              }
              {
                props.order.orderType == "Deliver" ?
                  <MotorcycleIcon className={classes.motorcycleIcon}></MotorcycleIcon>
                  : null
              }
            </span>
            <span className={classes.orderTypeText}>
              {
                props.order.orderType == "SelfOrder" ?
                  translateGui(21)
                  : null
              }
              {
                props.order.orderType == "Collect" ?
                  translateGui(22)
                  : null
              }
              {
                props.order.orderType == "Deliver" ?
                  translateGui(23)
                  : null
              }
            </span>
          </div>

          <span className={classes.orderDetails + ' ' + classes.tableNo} >
            {props.order.orderType == "SelfOrder" ? translateGui(24) + ': ' + props.order.tableNumber : null}
          </span>
          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '1.5rem', marginTop: '10px', }}>




            <span className={classes.orderDetails}>
              saat: {getFormattedDateTime(props.order.orderDate)}
            </span>




            <span className={classes.orderDetails}>
              {translateGui(25)}: {(props.order.orderNumber).substring(0, 6)}
            </span>

            <span className={classes.orderDetails} style={{ fontStyle: 'italic' }}> {props.order.note}</span>
          </div>

          <div className={classes.orderDetailsWrapper}>

            {
              props.order.orderType == "Collect" ?
                <div className={classes.orderDetails}>
                  <span> {props.order.email}</span>
                  <span> {props.order.phone}</span>
                </div>
                : null
            }
            {
              props.order.orderType == "Deliver" ?
                <div className={classes.orderDetails}>
                  <span> {props.order.paymentType == "PayOnDelivery" ? translateGui(108):translateGui(107)}</span>
                  <span> {props.order.name}</span>
                  <span> {props.order.phone}</span>
                  <span> {props.order.email}</span>
                  <span> {props.order.address}</span>
                  <span> {props.order.postCode}</span>

                </div>
                : null
            }
          </div>
          <div className={classes.orderDetails}>

          </div>
        </div>
        <div className={classes.col2}>
        </div>
        <div className={classes.col3}>
          <Table className={classes.table}>
            <thead>
              <tr>

                <th>{translateGui(26)}</th>
                <th>{translateGui(27)}</th>
                <th align="right" className="ilk-harf-buyuk">{translateGui(28)}</th>

              </tr>
            </thead>
            <tbody>
              {
                props.order.orderDetail.map(
                  (orderItem, index) =>
                    <OpenOrderLine key={index} order={props.order} orderItem={orderItem} optionGroups={props.optionGroups}></OpenOrderLine>
                )
              }

              <tr >

                <td align="right">



                </td>
                <td align="right" style={{ paddingTop: '10px' }}>

                  {parseFloat(props.order.orderAmount).toFixed(2) + ' '}  {props.currency}

                </td>

                <td>

                </td>
              </tr>

            </tbody>
          </Table>
        </div>
      </div>

    </React.Fragment>
  );
}

//export default OpenOrders__Details__Small;

const useStyles = makeStyles({

  root: {
    width: '95%',
    borderRadius: 0,
    backgroundColor: 'white',
    boxShadow: '5px 5px 5px 0px rgba(0, 0, 0, 0.25)',
    display: 'flex',
    justifyContent: 'flex-start',
    
    '@media (max-width : 767px)':{
      flexDirection: 'column',
    }
  },

  table: {

    '@media (max-width : 767px)':{
      width: '85%',
    },

    '& th': {
      textAlign: 'left',
      fontFamily: 'Open Sans',
      color: '#615f5f',
      textTransform: 'capitalize',
      padding: '10px 5px',
      width: '200px',
      fontSize: '0.9rem',

    },

    '& td': {
      textAlign: 'left',
      padding: '1px 5px',
      opacity: '0.7',
      fontSize: '0.8rem',
    },

    '& tr:nth-child(1)>td': {
      paddingTop: '10px',
    },


    '&>thead>tr': {
      backgroundColor: '#f7f7f7',
    },



  },

  card: {
    width: '350px',
    //marginTop: '10px',
    //marginLeft: '10px',

    '@media (min-width : 600px)': {
      // width: 'calc(100% - 20px)',
    },
    '& td': {
      //borderBottom : 'none',
      padding: '0px 24px 0px 16px',
      fontSize: '12px',
    },
    '& th': {
      padding: '16px 16px 0px 16px',
    },
    '& tbody>tr:not(:last-child):nth-child(2n-1)': {
      //backgroundColor : '#604a0814',  
      backgroundColor: 'rgb(247, 247, 247)',

    }
  },
  orderDetails: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '0.8rem',
    padding: '0 10px',
  },
  orderTypeWrapper: {
    display: 'flex',
    paddingTop: '0.5rem',
    '& > span:nth-child(2)': {
      //marginLeft: '10px',
    }
  },
  orderTypeText: {
    fontSize: '0.9rem',
    fontFamily: 'Open Sans',
    textTransform: 'capitalize',
    marginLeft: '5px',
    fontWeight: 600,
    color: '#615f5f',
  },
  
  motorcycleIcon: {
    color: '#5dbcd2',
    fonttSize: '1.2rem',
  },
  directionsWalkIcon: {
    color: 'rgb(255, 139, 81)',
    fonttSize: '1.2rem',
  },
  restaurantIcon: {
    color: 'rgb(130, 204, 96)',
    fontSize: '1.2rem',
  },
  col1: {
    padding: '10px',
    minWidth: '200px',

  },
  col2: {
    borderLeft: '1px solid #ece9e9',
    height: '120px',
    alignSelf: 'center',

    
    '@media (max-width : 767px)':{
      display: 'none',
    }
  },

  col3: {
    width: '100%',
    marginLeft: '20px',
    padding: '10px',
  },

  orderDetails: {
    "textTransform": "capitalize",
    "fontSize": "0.8rem",
    "fontFamily": "'Open Sans'",
    "fontWeight": "700",
    "opacity": "0.5",
    display: 'flex',
    flexDirection: 'column',
    //"maxWidth": '150px',
  },
  orderDetailsWrapper:{
    maxWidth: '150px',
    marginLeft: '1.5rem',
  },
  tableNo: {
    "marginLeft":"1.55rem",
    "fontSize":"0.8rem",
    "opacity":"0.6",
    "display":"inline-block",
    "position":"relative",
    "top":"-5px"
  },



});